<div class="productDetailsSection --insurance">
  <h3>{{insurance.tabName}}</h3>
  <div class="productDetailsSection__insurance">
    <div class="productDetailsSection__left">
      <h4>{{insurance.title}}</h4>
      <ul *ngIf="insurance.benefits">
        <li *ngFor="let element of insurance.benefits">{{element}}</li>
      </ul>
      <a [href]="insurance.linkUrl" target="_blank">{{insurance.linkName}}</a>
    </div>
    <div>
      <div [innerHTML]="insurance.content"></div>
      <p class="productDetailsSection__insurance__value"><span [innerHTML]="'productDetails.insurance.value.text1' | translate"></span> {{insurance.insuranceValue}}% {{'productDetails.insurance.value.text2' | translate}}</p>
    </div>
  </div>
</div>
